
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ckan",
      function () {
        return require("private-next-pages/solutions/ckan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ckan"])
      });
    }
  